export default __webpack_public_path__ + "static/media/client-8.7c10f35c.png";